"use client"
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { Button, Form } from "react-bootstrap";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { formatDurations } from '../../lib/function';
import { FaArrowRight } from "react-icons/fa";

// Define TypeScript interfaces for the data structure
interface PriceOption {
  value: number;
  label: string;
}

interface PackageData {
  title: string;
  priceOptions: PriceOption[];
  features: string[];
  configureUrl : string;
}


type DurationPlan = {
  type: string;
  currency: string;
  period: number;
  price: number;
  actuall_price: number;
  desc: string;
  discount: number;
};

type DurationMap = {
  [key: string]: DurationPlan;
};

const VpnPackages = () => {
  const [pricingData, setPricingData] = useState<PackageData[] | null>(null);
  const pathname = usePathname();
  const rawSlug = pathname?.split("/").pop() || "";
  
  useEffect(() => {
    const fetchPricingData = async () => {
      try {
        const response = await fetch('/api/plan', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            rawSlug
          }),
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        let mockPackages: Record<string, PackageData[]> = {};
        mockPackages = result.data.slice(0, 20).map((item: {id: number, name: string, description:string, duration: DurationMap}): PackageData => ({
            title: item.name,
            priceOptions: formatDurations(item.duration),
            features: item.description.split(/\r?\n/)
            .map(line => {
                const [key, ...rest] = line.split(':');
                return (key.trim() + ' - ' + rest.join(':').trim()).replace(/\s*-\s*$/, '');
            }),
            configureUrl: `${process.env.NEXT_PUBLIC_API_BASE_URL}/cart.php?a=add&pid=${item.id}&billingcycle=${item.duration.annually.type}`
          }));

        const data: PackageData = mockPackages;
        setPricingData(data);
      } catch (error) {
        console.error("There was an error fetching the data: ", error);
      }
    };

    fetchPricingData();
  }, [rawSlug]);

  if (!pricingData || !pathname) return <div>Loading...</div>;

  return (
    <div className="custMargin">
      <div className="container">
        <h4 className="text-center fw-bold display-6 mb-3">Anonymous VPN Service</h4>
        <div className="d-flex justify-content-center">
        {pricingData.map((packageData, index) => (
          <div key={index} className="col-lg-5 col-md-8 col-12">
            <div className="vpnPack">
              <ul>
                {packageData.features.map((feature, index) => (
                  <li key={index}>
                    <FontAwesomeIcon icon={faCircleCheck} className="text-success"/> {feature}
                  </li>
                ))}
              </ul>
              <h6 className="textOrange fs-5 fw-bold mt-3">Package Price</h6>
              <Form.Select size="lg">
                {packageData.priceOptions.map(({ value, label, selected }, index) => (
                  <option key={index} value={value} selected={selected}>
                    {label}
                  </option>
                ))}
              </Form.Select>
              <div className="d-grid gap-2 mt-4">
                {/* <Button variant="primary" size="lg">
                  <Link   >
                    <span className="text-white text-decoration-none">Order Your VPN Now!</span>
                  </Link>
                </Button> */} 
                <Link href={packageData.configureUrl} className="text-decoration-none" passHref> 
                  <Button className="orangeBtn fw-semibold"  size="lg">
                ORDER <FaArrowRight className="" />
                </Button> 
                </Link>

              </div>
            </div>
          </div>
         ))}
        </div>
      </div>
    </div>
  );
};

export default VpnPackages;
